var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapLidar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#1E2447"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93262 7.47915C8.93262 7.00209 9.31935 6.61536 9.79641 6.61536H17.3546C17.8316 6.61536 18.2183 7.00209 18.2183 7.47915V9.42267C18.2183 9.89973 17.8316 10.2865 17.3546 10.2865H16.7674C16.791 10.3878 16.7966 10.4956 16.7808 10.6057L16.5973 11.8818C16.5362 12.307 16.1719 12.6226 15.7423 12.6226H15.6804L15.6263 13.1775C15.5832 13.62 15.2112 13.9576 14.7666 13.9576H12.3843C11.9397 13.9576 11.5677 13.62 11.5246 13.1775L11.4706 12.6226H11.4087C10.9791 12.6226 10.6148 12.307 10.5537 11.8818L10.3702 10.6057C10.3543 10.4956 10.3599 10.3878 10.3836 10.2865H9.79641C9.31935 10.2865 8.93262 9.89973 8.93262 9.42267V7.47915Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4953 10.0705H17.3546C17.7124 10.0705 18.0024 9.78046 18.0024 9.42267V7.47915C18.0024 7.12135 17.7124 6.8313 17.3546 6.8313H9.79641C9.43861 6.8313 9.14856 7.12135 9.14856 7.47915V9.42267C9.14856 9.78046 9.43861 10.0705 9.79641 10.0705H10.6557L10.5939 10.3355C10.5763 10.4111 10.572 10.4918 10.5839 10.575L10.7674 11.851C10.8133 12.1699 11.0865 12.4067 11.4087 12.4067H11.6665L11.7396 13.1566C11.7719 13.4885 12.0509 13.7416 12.3843 13.7416H14.7666C15.1001 13.7416 15.3791 13.4885 15.4114 13.1566L15.4845 12.4067H15.7423C16.0645 12.4067 16.3377 12.1699 16.3835 11.851L16.567 10.575C16.579 10.4918 16.5747 10.4111 16.5571 10.3355L16.4953 10.0705ZM17.3546 10.2865C17.8316 10.2865 18.2183 9.89973 18.2183 9.42267V7.47915C18.2183 7.00209 17.8316 6.61536 17.3546 6.61536H9.79641C9.31935 6.61536 8.93262 7.00209 8.93262 7.47915V9.42267C8.93262 9.89973 9.31935 10.2865 9.79641 10.2865H10.3836C10.3674 10.3559 10.3597 10.4283 10.3615 10.5024C10.3623 10.5365 10.3652 10.571 10.3702 10.6057L10.5537 11.8818C10.6148 12.307 10.9791 12.6226 11.4087 12.6226H11.4706L11.5246 13.1775C11.5677 13.62 11.9397 13.9576 12.3843 13.9576H14.7666C15.2112 13.9576 15.5832 13.62 15.6263 13.1775L15.6804 12.6226H15.7423C16.1719 12.6226 16.5362 12.307 16.5973 11.8818L16.7808 10.6057C16.7858 10.571 16.7886 10.5365 16.7895 10.5024C16.7913 10.4283 16.7836 10.3559 16.7674 10.2865H17.3546Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.80762 17.5937L9.04683 8.09204L9.25122 8.16172L6.01201 17.6634L5.80762 17.5937Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3428 17.5949L18.2115 8.09326L18.0064 8.16085L21.1377 17.6625L21.3428 17.5949Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55545 18.2765H5.25977L5.90761 17.6287L6.55545 18.2765Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90851 17.4761L6.81703 18.3846H5L5.90851 17.4761ZM5.52134 18.1686H6.29568L5.90851 17.7815L5.52134 18.1686Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2224 17.4127H12.9268L13.5746 16.7649L14.2224 17.4127Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5745 16.6122L14.483 17.5207H12.666L13.5745 16.6122ZM13.1874 17.3047H13.9617L13.5745 16.9176L13.1874 17.3047Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.781 18.0606H20.4854L21.1332 17.4127L21.781 18.0606Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1321 17.26L22.0407 18.1685H20.2236L21.1321 17.26ZM20.745 17.9526H21.5193L21.1321 17.5654L20.745 17.9526Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4658 16.8729V13.8496H13.6818V16.8729H13.4658Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64974 12.6617L11.8258 13.2026L11.7981 13.4167L7.622 12.8758L7.64974 12.6617Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64974 12.6617L11.8258 13.2026L11.7981 13.4167L7.622 12.8758L7.64974 12.6617Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5729 12.6617L15.3968 13.2026L15.4246 13.4167L19.6007 12.8758L19.5729 12.6617Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLidar);
export default __webpack_public_path__ + "static/media/map-lidar.b08471da.svg";
export { ForwardRef as ReactComponent };